module.exports = __webpack_public_path__ + "img/resul_four_day_march_logo_transbg_2023.dd3892dd.png";